import RecurringInformation from './RecurringInformation';

export default RecurringInformation;
